module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/fernhill-800.7a983c8ea6467e8e.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/fernhill-800.7a983c8ea6467e8e.jpg",width: 800,height: 591}],
        src: "https://static.sniffspot.com/packs/img/fernhill-800.7a983c8ea6467e8e.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/fernhill-800.7a983c8ea6467e8e.jpg"},
        
        width: 800,
        height: 591
      }